const MEMBER_LANDED_MARKER = 'was added to the loan';

export const memberWasAdded = (message?: string | null) => !!message?.includes(MEMBER_LANDED_MARKER);
